import SpriteSymbol from "../../../node_modules/_svg-baker-runtime@1.4.7@svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/_svg-sprite-loader@4.3.0@svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-progress",
  "use": "icon-progress-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-progress\"><path d=\"M462 326h72v184h110v72H462V326z m501.712-101.422l-61.622 191.96-209.8-74.216 23.942-67.7 91.924 32.52A358.138 358.138 0 0 0 512 152c-198.504 0-360 161.496-360 360s161.496 360 360 360 360-161.496 360-360h72a432 432 0 0 1-737.47 305.47 432.036 432.036 0 0 1 535.15-671.416 433.508 433.508 0 0 1 130.786 127.872l22.886-71.3z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/progress.svg
// module id = qPYD
// module chunks = 12